import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import ReactLink from '../link/link';
import { useLocale } from 'next-intl';

const CustomLink = props => {
  const { link, children, className, onClick = () => {}, ...anchorProps } = props;
  const locale = useLocale();

  if (link.type === 'home') {
    return (
      <Link
        href={{
          pathname: '/time',
          query: { slug: 'index', lang: locale, filters: null, page: 1 }
        }}
        as="/"
        className={className}
        onClick={onClick}
        {...anchorProps}
      >
        {children}
      </Link>
    );
  }

  if (link.type === 'listPage') {
    return (
      <Link
        href={`/${locale}/overview/${link.slug}`}
        as={link.url}
        className={className}
        onClick={onClick}
        {...anchorProps}
      >
        {children}
      </Link>
    );
  }

  if (link.type === 'exhibition') {
    return (
      <Link
        href={{
          pathname: '/exhibition',
          query: { lang: locale, slug: link.slug }
        }}
        as={link.url}
        className={className}
        onClick={onClick}
        {...anchorProps}
      >
        {children}
      </Link>
    );
  }

  if (link.type === 'custom') {
    return (
      <ReactLink
        href={link.url}
        target="_blank"
        className={className}
        onClick={onClick}
        {...anchorProps}
      >
        {children}
      </ReactLink>
    );
  }

  return (
    <Link
      href={{ pathname: '/universal', query: { uri: link.url } }}
      as={link.url}
      className={className}
      onClick={onClick}
      {...anchorProps}
    >
      {children}
    </Link>
  );
};

CustomLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  link: PropTypes.shape({
    type: PropTypes.string,
    slug: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func
};

export default CustomLink;
